/* eslint no-eval: 0 */
import forEach from "lodash/forEach";
import pollConfig from "../config/pollConfig";
import PollQuestion from "./PollQuestion";

export default class PollConfig {
  constructor() {
    this.config = pollConfig;
  }

  getConfig() {
    return this.config;
  }

  pagesCount() {
    return this.config.pages.length;
  }

  getPages() {
    return this.config.pages;
  }

  getPage(page) {
    return this.config.pages[page];
  }

  getQuestions(page) {
    return this.getPage(page).questions.map(
      (question, index) => new PollQuestion(page, index, question)
    );
  }

  initialValues() {
    const initV = {};
    forEach(this.config.pages, vValue => {
      forEach(vValue.questions, cValue => {
        if (cValue.initValue) {
          initV[cValue.id] = cValue.initValue;
        }
      });
    });
    return initV;
  }

  canShow(page, values) {
    const show = this.config.pages[page].show;
    if (show && values) return eval(show);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utils/PollConfig.js